const SITE_URL = siteVariables.site_url;
const AJAX_URL = siteVariables.ajax_url;

document.addEventListener("DOMContentLoaded", (event) => {
	const loadMoreBtn = document.getElementById("loadMoreBtn");
	let page = 1;
	let maxPages;
	const postCategoriesSelect = document.getElementById("postCategories");
	const searchTerm = document.getElementById("search-blog") ? document.getElementById("search-blog").value : "";
	let postCategories = [];
	const blogList = document.getElementById("blogList");

	// If load more btn is clicked
	if (loadMoreBtn && blogList) {
		postCategories = Array.from(postCategoriesSelect.selectedOptions).map((option) => +option.value);
		loadMoreBtn.addEventListener("click", async (e) => {
			e.preventDefault();
			page++;
			await getPosts();
		});
	}

	// If categories are selected
	if (postCategoriesSelect) {
		postCategoriesSelect.addEventListener("click", async (e) => {
			postCategories = Array.from(postCategoriesSelect.selectedOptions).map((option) => +option.value);
			const NEW_URL = new URL(window.location.href);
			if (postCategories.length) {
				NEW_URL.searchParams.set("cat", postCategories);
			} else {
				NEW_URL.searchParams.delete("cat");
			}

			window.history.replaceState({}, "", NEW_URL.toString());
			page = 1;
			await getPosts();
		});
	}

	async function getPosts() {
		const bodyData = {
			action: "tesl_blog_archive_ajax",
			nonce: siteVariables.tesl_blog_nonce,
			page,
			postCategories,
			searchTerm,
		};
		try {
			const res = await fetch(AJAX_URL, {
				method: "POST",
				headers: { "Content-Type": "application/x-www-form-urlencoded" },
				body: new URLSearchParams(bodyData).toString(),
			});
			if (!res.ok) retrun;
			const resData = await res.json();
			if (!resData.success) return;

			const { data } = resData;
			if (page === 1) {
				blogList.innerHTML = data.html;
			} else {
				blogList.innerHTML += data.html;
			}

			if (loadMoreBtn) {
				if (page === data.maxPages) {
					loadMoreBtn.style.display = "none";
				} else {
					loadMoreBtn.style.display = "inline-block";
				}
			}
		} catch (err) {
			console.error("Error:", err);
		}
	}
});
